import request from "@src/utils/request";

export function getUserGeneralSettings() {
  return request().get("/api/v1/current-user/general-settings/").send();
}

export function setUserGeneralSettings(
  formData: FormData | Record<string, any>,
) {
  return request()
    .set("Content-Type", null)
    .patch("/api/v1/current-user/general-settings/")
    .send(formData);
}

export function getUserNotificationSettings() {
  return request().get("/api/v1/current-user/notification-settings/").send();
}

export function setUserNotificationSettings(
  formData: FormData | Record<string, any>,
) {
  return request()
    .patch("/api/v1/current-user/notification-settings/")
    .send(formData);
}

export function searchHiddenItemOptions(search: string) {
  return request().query({ search }).get("/api/v1/hidden-item-options/").send();
}

export function getHiddenItems(filters?: Record<string, any>) {
  return request()
    .get("/api/v1/hidden-items/")
    .query(filters || {})
    .send();
}

export function createHiddenItem(formData: FormData | Record<string, any>) {
  return request().post("/api/v1/hidden-items/").send(formData);
}

export function deleteHiddenItem(hiddenItemId: string) {
  return request().delete(`/api/v1/hidden-items/${hiddenItemId}/`).send();
}

export function getUserDefaultSearchFilters() {
  return request().get("/api/v1/current-user/default-search-filters/").send();
}

export function setUserDefaultSearchFilters(
  formData: FormData | Record<string, any>,
) {
  return request()
    .patch("/api/v1/current-user/default-search-filters/")
    .send({ defaultSearchFilters: formData });
}
